module.exports = __webpack_public_path__ + "img/benefit-3-job.e44f3d35.png";